import { User } from "../_modelsTS/User";
import { NfcActions } from "../../Budgets/_actions/NfcActions";
import { CapsuleButton } from "../../Common/_components";
import { ValidatedTextInput } from "../../Common/_components/ValidatedTextInput";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { FileUploadComponent } from "../_components";
import { Selectors } from "../_reducers/app.reducer";
import { LocationCustomization } from "../_models/LocationCustomization";
import { CircleAvatar } from "../_components/CircleAvatar";

function NFCCardFieldInput({textName, initialValue, setValue, isRequired }) {

    return (
        <div>
            <div className="p-1 py-1">
                <div
                    className="d-flex align-items-center justify-content-between"
                >
                    <p>
                        {textName}
                    </p>
                    <ValidatedTextInput
                        isRequired={isRequired}
                        isEditable
                        value={initialValue}
                        className='w-50'
                        setValue={setValue}
                    />
                </div>
            </div>
        </div>
    );
}

function NFCCardFileUpload({textName, textColor, avatar, handleUpload }) {

    return (
        <div>
            <div className="p-1 py-1 ">
                <div
                    className="d-flex align-items-center justify-content-left"
                >
                    <div className="d-flex flex-row align-items-center">
                        <p>
                            {textName}
                        </p>
                        {avatar && 
                        <CircleAvatar
                            color="white"
                            textColor={textColor}
                            className="ml-2"
                            style={{ height: "40", width: "40" }}
                            srcImg={avatar}
                        />}
                    </div>
                    <div className="ml-auto">
                        <FileUploadComponent
                            onUpload={handleUpload}
                            isUploading={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

type NFCCardUserConfigurationProps = {
    user: User,
    onSave: (user) => void;
};

export function NFCCardUserConfiguration({user, onSave = (user) => {}}: NFCCardUserConfigurationProps) {

    const [name, setName] = useState(user.name);
    const [lastName, setLastName] = useState(user.lastName);
    const [email, setEmail] = useState(user.email);
    const [vatID, setVatID] = useState(user.clockinLegalId);
    const [additionalInfo, setAdditionalInfo] = useState(user.clocingAdditonalInfo);
    const cardCode = user.nfcCard?.code;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let customization               = LocationCustomization();
    customization                   = useSelector(Selectors.getLocationCustomization);

    function handleSave() {
        dispatch(NfcActions.updateNfcCard(cardCode, email, name, lastName, vatID, additionalInfo));
        onSave(user);
    }

    function handleUploadAvatar(avatar) {
        dispatch(NfcActions.uploadAvatarNfcCard(cardCode, avatar));
        setTimeout(() => {
            onSave(user);
        }, 200);
    }

    useEffect(() => {
        // Reset local state to match the incoming prop data
        setName(user.name);
        setLastName(user.lastName);
        setEmail(user.email);
        setVatID(user.clockinLegalId);
        setAdditionalInfo(user.clocingAdditonalInfo);
    }, [user]); // 👈 CRITICAL dependency array


    return <div>
        <NFCCardFileUpload 
            textName={t('global_avatar')}
            textColor={customization?.headerColor ?? "#202020"}
            avatar={user.avatar}
            handleUpload={handleUploadAvatar}
        />
        <div className='mt-2'></div>
        <NFCCardFieldInput
            textName={t('global_name')}
            isRequired={false}
            initialValue={name}
            setValue={setName}
        />
        <div className='mt-1'></div>
        <NFCCardFieldInput
            textName={t('global_last_name')}
            isRequired={false}
            initialValue={lastName}
            setValue={setLastName}
        />
        <div className='mt-1'></div>
        <NFCCardFieldInput
            textName={t('global_email')}
            isRequired={false}
            initialValue={email}
            setValue={setEmail}
        />
        <div className='mt-1'></div>
        <NFCCardFieldInput
            textName={t('mod_clockin_nif')}
            isRequired={false}
            initialValue={vatID}
            setValue={setVatID}
        />
        <div className='mt-1'></div>
        <NFCCardFieldInput
            textName={t('mod_clockin_info')}
            isRequired={false}
            initialValue={additionalInfo}
            setValue={setAdditionalInfo}
        />
        <div className='mt-3'></div>
        <CapsuleButton
            onClick={handleSave}
            text={t("global_save")}
        />
    </div>
}